var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraphs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1585.6 638.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "graphs_and_statistics_outline_II",
    "data-name": "graphs and statistics/outline_II",
    transform: "translate(2.6 2.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "graphs_and_statistics_outline_II-2",
    "data-name": "graphs and statistics/outline_II"
  }, /*#__PURE__*/React.createElement("g", {
    id: "graphs_and_statistics_outline_II-3",
    "data-name": "graphs and statistics_outline_II"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flower_1_",
    transform: "translate(115 93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "leaves_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "leaf_IV_1_",
    transform: "translate(72 60)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M10.529,14.177C23.51-.563,43.377-3.859,62.046,4.522,80.732,12.911,95.118,31.493,99.884,55.27l.472,2.411.164.822c3.947,19.6,7.747,28.251,15.8,36.919l.28.3c4.264,4.432,22.753,20.943,25.431,23.452a3,3,0,1,1-4.1,4.378l-2.583-2.357c-6.035-5.469-19.816-17.872-23.284-21.539l-.137-.146c-8.906-9.586-13.139-19.224-17.287-39.818q-.251-1.247-.505-2.565c-8.709-45.49-55.049-66.293-79.1-38.981C4.647,29.933,3.6,47.719,10,68.969c4.613,15.316,13.293,31.91,19.623,39.848l.282.35c3.119,3.835,4.464,10.639,6,26.487l1.477,16.056.314,3.253c.451,4.577.9,8.666,1.394,12.706a282.075,282.075,0,0,0,6.21,34.616q.658,2.617,1.37,5.167a3,3,0,1,1-5.779,1.615q-.734-2.626-1.41-5.319A287.893,287.893,0,0,1,33.134,168.4l-.229-1.893c-.413-3.482-.795-7.042-1.18-10.951l-.4-4.19c-.339-3.644-1.077-11.822-1.225-13.4l-.164-1.722c-1.384-14.24-2.661-20.81-4.679-23.291-6.851-8.4-16.091-25.966-21-42.255C-2.679,47.67-1.514,27.851,10.529,14.177Z",
    transform: "translate(-2.98 -2.159)",
    fill: "#fe7624"
  })), /*#__PURE__*/React.createElement("g", {
    id: "leaf_II_1_",
    transform: "translate(0 220)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M34.433.191C51.6-1.342,69.878,6.4,83.3,21.906l1.3,1.518c7.505,8.741,12.78,13.7,17.923,16.892,4.256,2.644,8.529,4.225,15.686,5.954l1.029.242c2.6.586,15.466,3.429,20.74,4.721l2.185.542c9.852,2.473,20.012,5.432,31.624,9.321C191,66.833,207.176,78.333,222.537,94.9a3,3,0,1,1-4.4,4.079c-14.726-15.884-30.1-26.809-46.253-32.195-11.891-3.982-22.217-6.971-32.26-9.461l-2.695-.654c-6.355-1.505-18.525-4.187-19.487-4.415-8.109-1.925-13.063-3.723-18.087-6.844C93.381,41.7,87.5,36.1,79.152,26.284,54.177-3.1,12.516.622,6.576,29.946,3.969,42.613,10.529,55.9,23.9,68.726,33.543,77.97,46.645,86.5,54.44,89.691l.392.158c4.013,1.572,7.906,6.125,15.681,17.221l9.01,12.948,1.62,2.3c4.366,6.145,8.33,11.44,12.4,16.482,13.414,16.619,26.887,29.011,41.737,37.111,9.1,4.982,17.588,7.025,26.045,6.749,6.346-.207,11.949-1.534,19.916-4.321l5.895-2.108,1.4-.488c1.333-.457,2.474-.825,3.573-1.147a28.826,28.826,0,0,1,9.735-1.434c7.08.387,12.572,4.711,17.172,13.827a3,3,0,1,1-5.357,2.7c-3.638-7.21-7.3-10.172-11.882-10.522l-.541-.031c-3.041-.146-4.588.161-12.359,2.87l-4.9,1.728c-8.892,3.151-15.167,4.682-22.455,4.92-9.534.311-19.088-1.988-29.119-7.481-15.639-8.53-29.662-21.427-43.528-38.607-3.911-4.845-7.714-9.9-11.843-15.683l-1.848-2.608-9.57-13.747-.945-1.342c-6.163-8.708-9.641-12.733-11.918-13.71l-.113-.046c-8.482-3.35-22.526-12.44-32.887-22.375C5.042,58.956-2.412,43.853.7,28.746,4,12.429,17.211,1.728,34.433.191Z",
    transform: "translate(-2.437 -2.641)",
    fill: "#fe7624"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M41.4,29.935C52.489,8.562,70.505-2.093,96.208.341c10.826,1.012,19.489,4.041,26.114,8.982a3,3,0,1,1-3.587,4.81c-5.686-4.24-13.3-6.9-23.089-7.818C72.462,4.12,56.725,13.426,46.729,32.7c-8.09,15.6-12.083,36.853-13.161,63.38l-.042,1.064c-.3,7.931-.315,14.223-.152,24.33l.125,7.616c.141,10.032.035,14.249-.539,19.418l-.031.273a50.385,50.385,0,0,1-6.7,20.856A68.8,68.8,0,0,1,14.07,184.362l-.594.559c-9.8,9.15-9.6,19.453-1.84,35.9l.78,1.625c.96,1.969,2,4,3.629,7.109l2.349,4.5a111.528,111.528,0,0,1,6,12.879c2.415,6.352,3.36,11.8,2.6,16.844l-.148.9c-.582,3.348-2.239,11.714-2.415,12.67a160.322,160.322,0,0,0-1.89,48.686c2.612,24.435,10.383,51.778,24.617,82.954a3,3,0,1,1-5.458,2.492c-14.494-31.746-22.441-59.711-25.125-84.808a165.812,165.812,0,0,1,1.773-49.4l.27-1.464c.444-2.309,2.144-10.918,2.445-12.918.563-3.741-.144-8.048-2.071-13.274l-.38-1a117.438,117.438,0,0,0-6-12.676l-2.764-5.291c-1.447-2.783-2.4-4.683-3.384-6.733C2.351,215.3.2,208.51.013,201.977-.215,194.028,2.634,187.008,9,180.895l.379-.359a63.962,63.962,0,0,0,11.684-13.96,44.021,44.021,0,0,0,5.819-17.764l.141-1.222c.515-4.755.61-8.865.474-18.507l-.158-9.816c-.118-8.409-.092-14.235.146-21.123l.044-1.227C28.575,69.084,32.708,46.7,41.4,29.935Z",
    transform: "translate(199.071 -2.628)",
    fill: "#fe7624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    d: "M52,159.306H3a3,3,0,0,1-2.993-3.217C2.371,123.569,6.652,96.31,13.094,72.752c2.084-7.62,4.417-14.9,6.935-21.63a189.574,189.574,0,0,1,8.388-19.245,145.007,145.007,0,0,1,9.911-16.763A114.894,114.894,0,0,1,49.834.931,2.952,2.952,0,0,1,51.977,0,2.986,2.986,0,0,1,55,3.006v153.3A3,3,0,0,1,52,159.306Zm-3-148.4-.128.156C36.231,26.5,26.14,47.792,18.881,74.335c-6.125,22.4-10.259,48.192-12.638,78.849l-.009.122H49Z",
    transform: "translate(267.6 251.294)",
    fill: "#fe7624"
  })), /*#__PURE__*/React.createElement("path", {
    id: "pot_2_",
    d: "M138.353,0a3,3,0,0,1,.176,5.995L138.353,6h-121A11.074,11.074,0,0,0,6.223,19.079L32.081,134.645a3,3,0,0,1-5.812,1.481l-.043-.171L.429,20.672C-1.986,10.165,6.095.2,17.021,0l.332,0Z",
    transform: "translate(180.347 404.6)",
    fill: "#2e186a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "whiteboard_2_",
    transform: "translate(434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shape_15_",
    d: "M766.3,637.4H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0H766.3a3,3,0,0,1,3,3V634.4A3,3,0,0,1,766.3,637.4ZM6,6V631.4H763.3V6Z",
    transform: "translate(-2.4 -2.6)",
    fill: "#2e186a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "graph_5_",
    transform: "translate(434 269)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "M45.8,72.8H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0H45.8a3,3,0,0,1,3,3V69.8A3,3,0,0,1,45.8,72.8ZM6,6V66.8H42.8V6Z",
    transform: "translate(-2.4 200.2)",
    fill: "#2e186a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-2",
    "data-name": "Rectangle",
    d: "M45.8,100.9H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0H45.8a3,3,0,0,1,3,3V97.9A3,3,0,0,1,45.8,100.9ZM6,6V94.9H42.8V6Z",
    transform: "translate(64.8 172.1)",
    fill: "#2e186a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-3",
    "data-name": "Rectangle",
    d: "M45.8,145.3H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0H45.8a3,3,0,0,1,3,3V142.3A3,3,0,0,1,45.8,145.3ZM6,6H6V139.3H42.8V6H6Z",
    transform: "translate(131.9 127.7)",
    fill: "#2e186a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    "data-name": "Rectangle",
    width: 42.8,
    height: 177.7,
    transform: "translate(202 92.3)",
    fill: "#fe7624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "arrow_1_",
    d: "M257.313.725a3.1,3.1,0,0,0-2.4-.7l-28,4.5a3.011,3.011,0,0,0-2.5,3.4,3.09,3.09,0,0,0,3.4,2.5l18.3-2.9-54.6,63.4-22.3-21.4a2.651,2.651,0,0,0-2.2-.8,2.814,2.814,0,0,0-2.1,1l-73.2,85-21.2-15.9a3.028,3.028,0,0,0-3.9.2l-65.7,63a2.988,2.988,0,0,0-.1,4.2,3.1,3.1,0,0,0,2.2.9,3.439,3.439,0,0,0,2.1-.8l63.9-61.3,21.5,16.1a3.077,3.077,0,0,0,4.1-.4l72.9-84.7,22.3,21.4a2.651,2.651,0,0,0,2.2.8,2.814,2.814,0,0,0,2.1-1l58.3-67.7-.4,23.7a2.946,2.946,0,0,0,3,3h0a3.009,3.009,0,0,0,3-3l.5-30.3A3.738,3.738,0,0,0,257.313.725Z",
    transform: "translate(1.987 0.375)",
    fill: "#fe7624"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layout_II_1_",
    transform: "translate(73 381)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lines_8_",
    transform: "translate(0 88)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    "data-name": "Path",
    d: "M187,0a3,3,0,0,1,.176,5.995L187,6H3A3,3,0,0,1,2.824.005L3,0Z",
    transform: "translate(1.6 -2.1)",
    fill: "#2e186a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    "data-name": "Path",
    d: "M138.5,0a3,3,0,0,1,.176,5.995L138.5,6H3A3,3,0,0,1,2.824.005L3,0Z",
    transform: "translate(1.6 25.9)",
    fill: "#2e186a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-7",
    "data-name": "Path",
    d: "M99,0a3,3,0,0,1,.176,5.995L99,6H3A3,3,0,0,1,2.824.005L3,0Z",
    transform: "translate(-2.4 57.3)",
    fill: "#2e186a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-8",
    "data-name": "Path",
    d: "M82.4,0a3,3,0,0,1,.176,5.995L82.4,6H3A3,3,0,0,1,2.824.005L3,0Z",
    transform: "translate(206.8 -2.1)",
    fill: "#2e186a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "oragne_bar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-9",
    "data-name": "Path",
    d: "M0,20.3l21.2,20V0Z",
    transform: "translate(91.9 7.4)",
    fill: "#fe7624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-10",
    "data-name": "Path",
    d: "M0,41.4,21.8,20.5,0,0Z",
    transform: "translate(61.4 7.3)",
    fill: "#fe7624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-11",
    "data-name": "Path",
    d: "M49,0H0L24.7,23.3Z",
    transform: "translate(120.5 0.3)",
    fill: "#fe7624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-12",
    "data-name": "Path",
    d: "M24.8,0,0,23.9H50.2Z",
    transform: "translate(62.7 31.9)",
    fill: "#fe7624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-13",
    "data-name": "Path",
    d: "M0,41.4,21.8,20.5,0,0Z",
    transform: "translate(119.1 7.3)",
    fill: "#fe7624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-14",
    "data-name": "Path",
    d: "M0,0V47.1L24.8,23.3Z",
    transform: "translate(0.6 4.5)",
    fill: "#fe7624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-15",
    "data-name": "Path",
    d: "M24.8,0,0,23.9H50.2Z",
    transform: "translate(5 31.9)",
    fill: "#fe7624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-16",
    "data-name": "Path",
    d: "M49,0H0L24.8,23.3Z",
    transform: "translate(5 0.3)",
    fill: "#fe7624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-17",
    "data-name": "Path",
    d: "M21.2,40.3V0L0,20.3Z",
    transform: "translate(149.6 7.4)",
    fill: "#fe7624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-18",
    "data-name": "Path",
    d: "M0,20.3l21.2,20V0Z",
    transform: "translate(34.2 7.4)",
    fill: "#fe7624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-19",
    "data-name": "Path",
    d: "M24.8,0,0,23.9H50.2Z",
    transform: "translate(120.5 31.9)",
    fill: "#fe7624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-20",
    "data-name": "Path",
    d: "M49,0H0L24.8,23.3Z",
    transform: "translate(62.7 0.3)",
    fill: "#fe7624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-21",
    "data-name": "Path",
    d: "M51.7,0H0V55.5H51.7Z",
    transform: "translate(176.8 0.3)",
    fill: "#fe7624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-22",
    "data-name": "Path",
    d: "M54.7,0H0V55.5H54.7Z",
    transform: "translate(234.5 0.3)",
    fill: "#fe7624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-23",
    "data-name": "Path",
    d: "M.4.45c.1.1.1.1.2.1V.45Z",
    transform: "translate(170.2 55.35)",
    fill: "#fe7624"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layout_3_",
    transform: "translate(538 121)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-5",
    "data-name": "Rectangle",
    d: "M34,37H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0H34a3,3,0,0,1,3,3V34A3,3,0,0,1,34,37ZM6,6V31H31V6Z",
    transform: "translate(79.1 53.9)",
    fill: "#2e186a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-6",
    "data-name": "Rectangle",
    d: "M121.5,41.7H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0H121.5a3,3,0,0,1,3,3V38.7A3,3,0,0,1,121.5,41.7ZM6,6V35.7H118.5V6Z",
    transform: "translate(-2.3 -2.3)",
    fill: "#2e186a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-24",
    "data-name": "Path",
    d: "M63.3,0a3,3,0,0,1,.176,5.995L63.3,6H3A3,3,0,0,1,2.824.005L3,0Z",
    transform: "translate(-2.3 84.9)",
    fill: "#2e186a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-25",
    "data-name": "Path",
    d: "M63.3,0a3,3,0,0,1,.176,5.995L63.3,6H3A3,3,0,0,1,2.824.005L3,0Z",
    transform: "translate(-2.3 70.2)",
    fill: "#2e186a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-26",
    "data-name": "Path",
    d: "M63.3,0a3,3,0,0,1,.176,5.995L63.3,6H3A3,3,0,0,1,2.824.005L3,0Z",
    transform: "translate(-2.3 55.6)",
    fill: "#2e186a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "lines_7_",
    transform: "translate(441 292)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-27",
    "data-name": "Path",
    d: "M167.7,0a3,3,0,0,1,.176,5.995L167.7,6H3A3,3,0,0,1,2.824.005L3,0Z",
    transform: "translate(-2.5 -2.3)",
    fill: "#2e186a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-28",
    "data-name": "Path",
    d: "M100.2,0a3,3,0,0,1,.176,5.995L100.2,6H3A3,3,0,0,1,2.824.005L3,0Z",
    transform: "translate(-2.5 11.8)",
    fill: "#2e186a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "circle_graph_4_",
    transform: "translate(69 71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-29",
    "data-name": "Path",
    d: "M99.1,57.3,212.1,0a126.927,126.927,0,0,1,13.7,57.3c0,69.5-57.2,126.7-126.7,126.7A126.586,126.586,0,0,1,0,136.2Z",
    transform: "translate(104.4 79)",
    fill: "#fe7624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-30",
    "data-name": "Path",
    d: "M107.7,0a3,3,0,0,1,.176,5.995L107.7,6H3A3,3,0,0,1,2.824.005L3,0Z",
    transform: "translate(297.6 36.6)",
    fill: "#2e186a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-31",
    "data-name": "Path",
    d: "M58.8,0a3,3,0,0,1,.176,5.995L58.8,6H3A3,3,0,0,1,2.824.005L3,0Z",
    transform: "translate(346.5 50.7)",
    fill: "#2e186a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-32",
    "data-name": "Path",
    d: "M40.1,0a3,3,0,0,1,.176,5.995L40.1,6H3A3,3,0,0,1,2.824.005L3,0Z",
    transform: "translate(365.2 64.9)",
    fill: "#2e186a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-33",
    "data-name": "Path",
    d: "M138.1,0a3,3,0,0,1,.176,5.995L138.1,6H3A3,3,0,0,1,2.824.005L3,0Z",
    transform: "translate(270.3 148.9)",
    fill: "#2e186a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-34",
    "data-name": "Path",
    d: "M28.3,0a3,3,0,0,1,.176,5.995L28.3,6H3A3,3,0,0,1,2.824.005L3,0Z",
    transform: "translate(380.1 160)",
    fill: "#2e186a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(46 27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-35",
    "data-name": "Path",
    d: "M83.5,0a3,3,0,0,1,.176,5.995L83.5,6H3A3,3,0,0,1,2.824.005L3,0Z",
    transform: "translate(-2.8 -2.1)",
    fill: "#2e186a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-36",
    "data-name": "Path",
    d: "M19.1,0a3,3,0,0,1,.176,5.995L19.1,6H3A3,3,0,0,1,2.824.005L3,0Z",
    transform: "translate(-2.8 9.3)",
    fill: "#2e186a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path-37",
    "data-name": "Path",
    d: "M29.4,81.7h0a2.986,2.986,0,0,1-2.35-1.133A124.147,124.147,0,0,1,0,4.332,3,3,0,0,1,2.968,1.3L124.868,0h.036a2.963,2.963,0,0,1,2.83,2.015,2.934,2.934,0,0,1-.97,3.337l-95.5,75.7A2.968,2.968,0,0,1,29.4,81.7ZM116.169,6.092,6.07,7.267l.016.444a117.947,117.947,0,0,0,23.6,66.447l.233.307Z",
    transform: "translate(55 138.9)",
    fill: "#fe7624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-38",
    "data-name": "Path",
    d: "M3,51.7a3,3,0,0,1-3-3V47.1A124.721,124.721,0,0,1,8.4,1.919,3.018,3.018,0,0,1,11.2,0a2.988,2.988,0,0,1,1.085.2l113.6,44.1a3,3,0,0,1-1.047,5.8L3.039,51.7ZM12.949,6.9l-.327.924A118.84,118.84,0,0,0,6.017,45.067l-.007.593,103.3-1.357Z",
    transform: "translate(60.2 83.999)",
    fill: "#fe7624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-39",
    "data-name": "Path",
    d: "M3,111.715A3.03,3.03,0,0,1,.4,110.186a2.911,2.911,0,0,1,0-2.968l60.1-105.7A3,3,0,0,1,64.594.391a124.111,124.111,0,0,1,29,22.711,123.093,123.093,0,0,1,21.013,30.172,3.005,3.005,0,0,1-1.356,4.013l-108.9,54.1A3.021,3.021,0,0,1,3,111.715ZM64.222,7.121,10.477,101.643l97.389-48.382-.189-.359a117.828,117.828,0,0,0-43.1-45.568Z",
    transform: "translate(205.085 10.799)",
    fill: "#fe7624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-40",
    "data-name": "Path",
    d: "M173.9,16.1A121.894,121.894,0,0,0,114.2,0h-2A121.762,121.762,0,0,0,0,77.3l113.4,44.5Z",
    transform: "translate(80.3 0.5)",
    fill: "#2e186a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-41",
    "data-name": "Path",
    d: "M83.5,0a3,3,0,0,1,.176,5.995L83.5,6H3A3,3,0,0,1,2.824.005L3,0Z",
    transform: "translate(-2.8 160.4)",
    fill: "#2e186a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-42",
    "data-name": "Path",
    d: "M32.1,0a3,3,0,0,1,.176,5.995L32.1,6H3A3,3,0,0,1,2.824.005L3,0Z",
    transform: "translate(-2.8 171.8)",
    fill: "#2e186a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "man_7_",
    transform: "translate(1052 110)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hand_II_7_",
    transform: "translate(0 463)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-43",
    "data-name": "Path",
    d: "M63.732.006a3,3,0,0,1,.374,5.988A188.984,188.984,0,0,0,44.926,8.2l-8.46,1.486-3.665.661c-.927.17-1.82.335-2.69.5l-1.291.244c-9.329,1.775-16.028,3.342-19.927,4.78A15.449,15.449,0,0,0,6.77,16.8c-.121.068-.224.131-.306.186l-.119.084c-.586.946-.407,1.444.921,2.254l.172.1c2.148,1.263,5.839,2.008,9.676,1.875a3,3,0,1,1,.207,6c-4.894.169-9.692-.8-12.924-2.7C.115,22.08-1.36,17.848,1.412,13.653c.941-1.432,2.674-2.406,5.4-3.413l.619-.222A147.572,147.572,0,0,1,26.369,5.449L29,4.948c1.539-.289,3.143-.583,4.883-.9L42.4,2.545A194.988,194.988,0,0,1,63.732.006Z",
    transform: "translate(-2.319 4.4)",
    fill: "#2e186a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-44",
    "data-name": "Path",
    d: "M37.843,64.487c-4.187,0-7.469-.641-9.756-1.906a6.488,6.488,0,0,1-3.66-5.665l-.005-.24a7.115,7.115,0,0,1,.109-1.283l.033-.175-.284-.012A19.194,19.194,0,0,1,16.451,53.1a9.379,9.379,0,0,1-4.606-4.454l-.069-.194a4.6,4.6,0,0,1,.282-3.316l.032-.074-.2.026a30.727,30.727,0,0,1-3.679.25A15.41,15.41,0,0,1,5.354,45.1L5.1,45.045A6.2,6.2,0,0,1,.537,41.86c-.9-1.876-.655-4.39.69-7.079,1.4-2.865,7.819-7.353,20.192-14.125l1.86-1.01c8.507-4.577,16.819-8.528,20.215-9.608l.59-.176C46.851,9.09,55.754,7.545,71.3,5.139l3.322-.511c4.2-.643,8.7-1.323,13.4-2.021L99.971.846,105.6.031a3,3,0,0,1,3.3,2.094l.047.171,14.1,58.4a3,3,0,0,1-2.741,3.7l-.175.005h-79.5l-.342.02C39.442,64.464,38.622,64.487,37.843,64.487ZM58.91,36.754a4.777,4.777,0,0,1,.991.1l.085.019a3,3,0,0,1,.158,5.81l-.87.254-1.6.481c-.8.243-1.526.469-2.233.691l-.592.187c-.924.294-1.817.583-2.652.859L51.17,45.5l-3.256,1.324L41.03,49.654c-2.079.846-3.417,1.372-4.769,1.876l-.537.2c-2.951,1.047-5.314,3.535-5.3,4.9,0,.288.2.563,1.135.971a16.482,16.482,0,0,0,6.149.9c.687,0,1.418-.02,2.175-.06l.454-.026.186-.006H116.31L103.746,6.36,96.788,7.375,88.906,8.541c-3.577.533-6.73,1.006-9.639,1.448L69.92,11.426c-13.461,2.1-21.822,3.553-24.178,4.2l-.2.057C41.6,16.813,31.832,21.747,23.9,26.138c-7.446,4.123-16.444,9.558-17.3,11.3a7.23,7.23,0,0,0-.56,1.414l-.034.154L6,39.082l.155.047.215.052A8.883,8.883,0,0,0,8.2,39.34a47.587,47.587,0,0,0,9.872-1.508l1.17-.279.054-.04a69.667,69.667,0,0,1,8.969-5.383l.409-.208c1.768-.892,3.735-1.823,5.847-2.767,3.66-1.636,7.734-3.307,12.109-4.969l1.21-.456c.57-.213,1.145-.426,1.711-.634l1.372-.5,1.222-.433a3,3,0,0,1,2.128,5.608l-1.623.581-1.038.376c-.952.349-1.912.707-2.853,1.065-4.269,1.622-8.236,3.249-11.79,4.838-2.031.908-3.912,1.8-5.591,2.646a56.272,56.272,0,0,0-11.135,7.161A17.141,17.141,0,0,0,18.03,46.68l-.12.158.185.145a11.582,11.582,0,0,0,2.741,1.48,11.723,11.723,0,0,0,4.2.825,8.749,8.749,0,0,0,2.89-.471L28,48.792l.254-.154A82.418,82.418,0,0,1,40.379,43l.653-.252c2.045-.783,4.257-1.584,6.574-2.38l1.422-.482,1.39-.556C55.268,37.4,57.411,36.754,58.91,36.754Z",
    transform: "translate(6.078 -2.6)",
    fill: "#2e186a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "body_5_",
    d: "M262,152.2a67.417,67.417,0,0,0-36.7-62.4L187.6,69.5l-4.1,18.6a37.5,37.5,0,0,1-44.7,28.5l-4.9-1.1a37.5,37.5,0,0,1-28.5-44.7l6.3-28.3c-7.2-5-12.9-11.8-15.6-20.6-.2-.6-.3-1.2-.5-1.7L58,0l-.1,291.7,102-20.9L155,202.3a3.007,3.007,0,0,1,6-.4l5.1,71.1a3.042,3.042,0,0,1-2.4,3.2L57.9,297.9v.8L0,309.3C11.4,311.5,24,368,24,368H229.4a35.94,35.94,0,0,0,35.9-36.5Z",
    transform: "translate(91 153.4)",
    fill: "#2e186a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "head_10_",
    transform: "translate(158)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "neck_5_",
    d: "M91.865,2.385a3,3,0,0,1,5.9,1.059l-.031.174L84.93,64.653A40.5,40.5,0,0,1,37.3,95.568l-.654-.14-4.9-1.1A40.5,40.5,0,0,1,.833,46.7l.14-.654,6.3-28.3a3,3,0,0,1,5.89,1.131l-.033.173-6.3,28.3A34.495,34.495,0,0,0,32.5,88.345l.556.129,4.9,1.1A34.487,34.487,0,0,0,78.937,63.94l.128-.555Z",
    transform: "translate(34.399 177.499)",
    fill: "#2e186a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "face_11_",
    d: "M56.557,185.853h0A69.543,69.543,0,0,1,30.739,180.8a53.259,53.259,0,0,1-17.63-11.385,40.344,40.344,0,0,1-10.252-16.8A73.117,73.117,0,0,1,0,131.725a146.844,146.844,0,0,1,3.372-30.606c.69-3.321,1.469-6.612,2.315-9.783.1-.366.186-.69.268-.99l.256-.919.243-.853.269-.915V87.65l.018-.063A340.691,340.691,0,0,1,19.008,52.819,267.358,267.358,0,0,1,34.681,20.93l.662-1.125.28-.466A39.781,39.781,0,0,1,50.551,4.647,40.628,40.628,0,0,1,70.163,0a57.14,57.14,0,0,1,5.976.324A75.666,75.666,0,0,1,94.607,4.855a87.037,87.037,0,0,1,9.3,4.094l1.02.535a93.02,93.02,0,0,1,18.09,12.358,68.717,68.717,0,0,1,12.549,14.6A62.035,62.035,0,0,1,142.913,53a70.011,70.011,0,0,1,2.473,18.211,87.265,87.265,0,0,1-3.908,25.969c-.86,2.838-1.835,5.585-2.9,8.167-.744,1.806-1.3,2.991-1.642,3.668l-.159.316-2.746,5.17q-.57,1.065-1.177,2.194l-1.806,3.347c-3.444,6.357-6.751,12.327-9.83,17.743-.436.765-.792,1.388-1.12,1.959l-1.444,2.51c-6.535,11.288-11.194,18.524-14.244,22.122l-.327.384c-4.593,5.385-8.763,9.609-14.19,12.72-4.809,2.757-10.728,4.763-20.43,6.922l-1.205.265A55.276,55.276,0,0,1,56.557,185.853ZM12.413,89.25h0c-.541,2.085-1.978,7.624-2.937,12.023l-.167.783-.3,1.442A139.4,139.4,0,0,0,6,131.683a67.19,67.19,0,0,0,2.588,19.165c3.331,10.793,11.775,19.229,24.418,24.395a63.712,63.712,0,0,0,23.55,4.611A49.272,49.272,0,0,0,66.986,178.8c17.733-3.855,22.854-6.649,32.233-17.586l.774-.911c2.845-3.423,7.493-10.708,13.813-21.654l1.089-1.893L116,134.815c3.326-5.848,6.943-12.389,10.749-19.443l.413-.768c.827-1.534,1.606-2.988,2.316-4.32l1.857-3.5.3-.6c.066-.134.144-.3.231-.484l.342-.743c.177-.4.335-.754.481-1.1l.338-.8c.991-2.406,1.9-4.97,2.7-7.623a81.282,81.282,0,0,0,3.65-24.181c-.193-24.441-12.735-43.442-37.277-56.477a79.941,79.941,0,0,0-9.607-4.3A69.663,69.663,0,0,0,75.508,6.291,51.181,51.181,0,0,0,70.157,6C57.119,6,47.143,11.673,40.5,22.863l-.645,1.1C29.237,42.168,19.521,65.365,12.5,89.277l-.089-.027Z",
    transform: "translate(23.176 23.568)",
    fill: "#2e186a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hair_II_1_",
    d: "M31.9,72.041c5.9-20,15.3-45.3,28.3-67.1a28.965,28.965,0,0,1,1.9-2.9c-10.5-8.2-27.6,8.7-39.4,43.6-6.1,18-22.7,27.1-22.7,27.1,12.7,11.1,24.2,6.3,31.7,0C31.8,72.341,31.8,72.041,31.9,72.041Z",
    transform: "translate(0.9 39.859)",
    fill: "#2e186a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nose_9_",
    d: "M13.714,1.891a3,3,0,0,1,5.635,2.054l-.06.166L6.926,35.152l8.214,3.035a3,3,0,0,1,1.831,3.687l-.056.167a3,3,0,0,1-3.687,1.831l-.167-.056-11.1-4.1A3,3,0,0,1,.152,35.959l.061-.169Z",
    transform: "translate(45.899 97.399)",
    fill: "#2e186a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "eye_II_13_",
    cx: 5.5,
    cy: 3.5,
    rx: 5.5,
    ry: 3.5,
    transform: "matrix(0.394, -0.919, 0.919, 0.394, 44.745, 100.343)",
    fill: "#2e186a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "eye_13_",
    cx: 5.5,
    cy: 3.5,
    rx: 5.5,
    ry: 3.5,
    transform: "translate(76.18 115.216) rotate(-77.555)",
    fill: "#2e186a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "brow_II_9_",
    d: "M.059,2.412A3,3,0,0,1,3.589.059,18.8,18.8,0,0,1,14.422,6.3a19.534,19.534,0,0,1,2.937,4.587,14.326,14.326,0,0,1,.846,2.265,3,3,0,0,1-5.76,1.671l-.091-.314a10.451,10.451,0,0,0-.448-1.121A13.577,13.577,0,0,0,9.87,10.207,12.819,12.819,0,0,0,2.412,5.942,3,3,0,0,1,.059,2.412Z",
    transform: "translate(92.599 86.499)",
    fill: "#2e186a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "brow_9_",
    d: "M7.334.035c3.589-.262,7.206.951,10.734,3.084a27.078,27.078,0,0,1,4.161,3.043,3,3,0,0,1-4.058,4.419l-.125-.111c-.153-.133-.391-.331-.7-.576a24.142,24.142,0,0,0-2.377-1.641A12.807,12.807,0,0,0,7.772,6.019,5.767,5.767,0,0,0,5,6.938l-.254.173A3,3,0,0,1,1.253,2.233,11.775,11.775,0,0,1,7.334.035Z",
    transform: "translate(45.9 67.128)",
    fill: "#2e186a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cap_5_",
    d: "M180.6,112.51l-33.9-17.2c4.3-25.2,1.6-64.2-45.7-86.2C27-25.29,0,48.81,0,48.81l169.5,85.5a12.31,12.31,0,0,0,16.5-5.4A12.111,12.111,0,0,0,180.6,112.51Z",
    transform: "translate(43.7 0.39)",
    fill: "#fe7624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "mouth_9_",
    d: "M28.879.745a3,3,0,0,1,.276,4.234,11.962,11.962,0,0,1-1.092,1.06,19.208,19.208,0,0,1-2.823,2.03c-6.363,3.774-14.4,4.254-23.616-.5A3,3,0,0,1,4.377,2.234c7.312,3.776,13.163,3.426,17.8.674a13.235,13.235,0,0,0,1.941-1.392l.246-.222.279-.274A3,3,0,0,1,28.879.745Z",
    transform: "translate(50.399 152.8)",
    fill: "#2e186a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hair_9_",
    d: "M78.861,36.1,7.361,0c-8.3,25.9-18.7,77.8,25.6,91.5,0,0,34.6,11.5,44.6.1,0,0-23.8-17.4-18.4-31.7,0,0,24.3,36,52.9,16.9C111.961,76.8,78.261,66,78.861,36.1Z",
    transform: "translate(107.639 85.1)",
    fill: "#2e186a"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "line_8_",
    d: "M1582.6,0a3,3,0,0,1,.176,5.995L1582.6,6H3A3,3,0,0,1,2.824.005L3,0Z",
    transform: "translate(-2.6 628.7)",
    fill: "#2e186a"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphs);
export default __webpack_public_path__ + "static/media/graphs.aad001f1757ab4ff1f717636f8730668.svg";
export { ForwardRef as ReactComponent };